export default "__VITE_ASSET__DaWW4AlF__"